<template>
    <el-dialog
        style="padding: 0 20px 20px 20px !important;"
        width="80%"
        :title="title"
        :visible.sync="visible"
        :before-close="handleClose"
    >
        <el-button size="mini" @click="addRecords" style="margin:20px"
            >添加记录</el-button
        >
        <el-button size="mini" @click="getList">刷新列表</el-button>
        <el-table
            :data="list"
            size="mini"
            ref="multipleTable"
            class="table_content mini_div"
            border
        >
            <el-table-column label="ID" width="80" align="center">
                <template slot-scope="scope">
                    <div>{{ scope.row.id }}</div>
                </template>
            </el-table-column>
			<el-table-column label="开始时间" min-width="150" align="center">
			    <template slot-scope="scope">
			        <div>{{ scope.row.start_date }}</div>
			    </template>
			</el-table-column>
			
			<el-table-column label="结束时间" min-width="150" align="center">
			    <template slot-scope="scope">
			        <div>{{ scope.row.end_date }}</div>
			    </template>
			</el-table-column>
            <!-- <el-table-column label="错误信息" min-width="150" align="center">
                <template slot-scope="scope">
                    <div>{{ scope.row.err_message }}</div>
                </template>
            </el-table-column> -->
            <el-table-column label="操作" width="210" fixed="right">
                <template slot-scope="scope">
                    <el-button
                        v-if="scope.row.tag === -1"
                        style="margin: 5px 0 5px 10px"
                        type="danger"
                        size="mini"
                    >{{ scope.row.err_message }}</el-button>
                    <el-button
                        style="margin: 5px 0 5px 10px"
                        type="success"
                        size="mini"
                        @click="downLoad(scope.row)"
                        v-if="scope.row.tag == '2'"
                        >下载</el-button
                    >
                    <el-button
                        v-if="scope.row.tag === 0"
                        style="margin: 5px 0 5px 10px"
                        type="success"
                        size="mini"
                        @click="startDecode(scope.row)"
                        >开始解析</el-button
                    >
                    <el-button
                        v-if="scope.row.tag === 1"
                        style="margin: 5px 0 5px 10px"
                        type="success"
                        size="mini"
                        >解析中</el-button
                    >
                    <!-- <el-button
                        v-if="scope.row.tag !== 0 && scope.row.tag !== 1"
                        style="margin: 5px 0 5px 10px"
                        type="success"
                        size="mini"
                        @click="startDecode(scope.row, 1)"
                    >重新解析</el-button
                    > -->
                    <el-button
                        style="margin: 5px 0 5px 10px"
                        type="danger"
                        size="mini"
                        @click="delete_records(scope.row)"
                        >删除</el-button
                    >
                </template>
            </el-table-column>
        </el-table>
        <el-row type="flex" justify="end">
            <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :page-size="query.limit"
                :page-sizes="[20, 50, 100]"
                :total="query.total"
                background
                style="float: right;margin-top: 10px; padding-bottom: 30px"
                layout="total, sizes, prev, pager, next"
            >
            </el-pagination>
        </el-row>
        <AddRecord
            :visible="ctrl.addRecordDialogVisible"
            :infoData="formData"
            :title="'添加记录'"
            @close-callback="closeCllback"
            @refresh="getList()"
        ></AddRecord>
    </el-dialog>
</template>

<script>
import * as api from "@/api/etyma/etyma";
import { downloadFileUrl, binary_download } from "../../utils/method";
import AddRecord from "./addRecord.vue";

export default {
    name: "BidList",
    components: { AddRecord },
    props: {
        visible: {
            type: Boolean,
            default: false
        },
        title: {
            type: String,
            default: ""
        },
	    formData: {
	        type: Object,
	        default: () => {}
	    },
    },
    data() {
        return {
            errorMsg: '',
            errorInfoShow: false,
            currentId: "",
            ctrl: {
                addRecordDialogVisible: false
            },
            list: [],
            query: {
                page: 1,
                limit: 20,
                ad_id: "",
				state: "",
				parent_asin: ""
            }
        };
    },
    created() {
        this.query.ad_id = this.formData.record_id;
        this.query.state = this.formData.state;
        this.query.parent_asin = this.formData.parent_asin;
        this.getList();
    },
    methods: {
        showErrorInfo(info){
            this.errorInfoShow = true;
            this.errorMsg = info.parsing_err_msg;
        },
		async startDecode(row, force = 0) {
		    if (force) {
		        await this.$confirm("是否重新运行解析任务", "提示", {
		            confirmButtonText: "确定",
		            cancelButtonText: "取消",
		            type: "warning"
		        });
		    }
		    let list = JSON.parse(JSON.stringify(this.list));
		    api.reduce_bid_parsing_file({
		        id: row.id,
		        force
		    }).then(() => {
		        const index = list.findIndex(item => item.id === row.id);
		        list[index].status = 1;
		        this.list = list;
		    });
		},
        getList() {
            api.out_three_page_show(this.query).then(res => {
                if (res.code === 0) {
                    this.list = res.data;
                } else {
                    this.$message({
                        type: "error",
                        message: res.message
                    });
                }
            });
        },
        // 关闭弹窗
        handleClose(isshow = false) {
            this.$emit("close-callback", isshow);
        },
        addRecords() {
            this.ctrl.addRecordDialogVisible = true;
        },
        delete_records(data) {
            this.$confirm("确认删除该记录吗?", "提示", {
                type: "warning"
            }).then(() => {
                api.out_three_page_delete({ id: data.id }).then(() => {
                    this.$message.success("删除成功");
                    this.getList();
                });
            });
        },
        closeCllback() {
            this.ctrl.addRecordDialogVisible = false;
        },
        //分页
        handleCurrentChange(val) {
            this.query.page = val;
            this.getList();
        },
        handleSizeChange(val) {
            this.query.limit = val;
            this.getList();
        },
        downLoad(data) {
            if (!data.filepath) {
                return this.$message({
                    type: "error",
                    message: "无法下载！"
                });
            }
            binary_download(
                "/apis/v1/common_file_export_by_path",
                "post",
                {},
                {
                    file_path: data.filepath
                },
                "application/vnd.ms-excel",
                `${data.asin} 前三页数据检测 ${data.id}.xlsx`
            );
        }
    }
};
</script>

<style type="text/scss" lang="scss" scoped>
/deep/ .el-card__header {
    padding: 14px 20px !important;
}
/deep/ .el-tabs__content {
    overflow: visible !important;
}
/deep/ .el-card {
    overflow: visible !important;
}
/deep/ .el-dialog__body {
    padding: 0px 20px 20px 20px !important;
}
.mini_div .el-button--mini {
    padding: 5px 5px !important;
}
/deep/ .el-table__expanded-cell {
    padding: 0 0 !important;
}
</style>
